export const REQUEST_SUBJECT = `Заявка на консультацию (секция «Контакты»)`;
